/* =========================================================================
   Litzzy header behaviour
   Desktop: hover/focus mega menu. Mobile: two-level slide-in drawer.
   Self-contained: no dependency on Minimog's header.js.
   ========================================================================= */
(function () {
  'use strict';

  var LOCK_CLASS = 'lzh-locked';

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function initHeader(root) {
    if (!root || root.dataset.lzhReady === '1') return;
    root.dataset.lzhReady = '1';

    /* ---------------------------------------------------------------- mega */
    var nav = root.querySelector('[data-lzh-nav]');

    function closeMega() {
      if (!nav) return;
      qsa(nav, '.lzh__tab.is-open').forEach(function (t) {
        t.classList.remove('is-open');
        t.setAttribute('aria-expanded', 'false');
      });
      qsa(nav, '.lzh__mega.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
    }

    function openMega(key) {
      closeMega();
      if (!nav || !key) return;
      var tab = nav.querySelector('[data-lzh-mega="' + key + '"]');
      var panel = nav.querySelector('[data-lzh-panel="' + key + '"]');
      if (!tab || !panel) return;
      tab.classList.add('is-open');
      tab.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
    }

    if (nav) {
      qsa(nav, '.lzh__tab').forEach(function (tab) {
        var key = tab.getAttribute('data-lzh-mega');
        tab.addEventListener('mouseenter', function () {
          if (key) { openMega(key); } else { closeMega(); }
        });
        tab.addEventListener('focus', function () {
          if (key) { openMega(key); } else { closeMega(); }
        });
      });

      nav.addEventListener('mouseleave', closeMega);

      nav.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMega();
      });

      // A click on a tab that owns a panel should still follow its link, but
      // on touch-capable laptops the first tap only opens the panel.
      qsa(nav, '.lzh__tab[data-lzh-mega]').forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          if (!window.matchMedia('(hover: none)').matches) return;
          if (!tab.classList.contains('is-open')) {
            e.preventDefault();
            openMega(tab.getAttribute('data-lzh-mega'));
          }
        });
      });
    }

    var searchInput = root.querySelector('.lzh__desktop .lzh__search-input');
    if (searchInput) searchInput.addEventListener('focus', closeMega);

    /* -------------------------------------------------------------- drawer */
    var drawer = root.querySelector('[data-lzh-drawer]');
    if (!drawer) return;

    var panes = drawer.querySelector('[data-lzh-panes]');

    function closeL2() {
      if (panes) panes.classList.remove('is-l2');
      qsa(drawer, '.lzh__l2').forEach(function (p) {
        p.classList.remove('is-in');
        window.setTimeout(function () {
          if (!p.classList.contains('is-in')) p.classList.remove('is-active');
        }, 260);
      });
    }

    function openL2(key) {
      var pane = drawer.querySelector('[data-lzh-l2="' + key + '"]');
      if (!pane) return;
      qsa(drawer, '.lzh__l2').forEach(function (p) {
        p.classList.remove('is-in');
        p.classList.remove('is-active');
      });
      pane.classList.add('is-active');
      // force a reflow so the transform transition actually runs
      void pane.offsetWidth;
      pane.classList.add('is-in');
      if (panes) panes.classList.add('is-l2');
      var body = pane.querySelector('.lzh__l2-body');
      if (body) body.scrollTop = 0;
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add(LOCK_CLASS);
      closeL2();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(LOCK_CLASS);
      closeL2();
    }

    qsa(root, '[data-lzh-open-drawer]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    qsa(drawer, '[data-lzh-close-drawer]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    qsa(drawer, '[data-lzh-open-l2]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openL2(el.getAttribute('data-lzh-open-l2'));
      });
    });

    qsa(drawer, '[data-lzh-back]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeL2();
      });
    });

    qsa(drawer, '[data-lzh-acc]').forEach(function (head) {
      head.addEventListener('click', function () {
        var body = head.nextElementSibling;
        if (!body || !body.classList.contains('lzh__acc-body')) return;
        var willOpen = !body.classList.contains('is-open');

        var group = head.closest('.lzh__l2-body');
        if (group) {
          qsa(group, '.lzh__acc-body.is-open').forEach(function (b) { b.classList.remove('is-open'); });
          qsa(group, '.lzh__acc-head.is-open').forEach(function (h) {
            h.classList.remove('is-open');
            h.setAttribute('aria-expanded', 'false');
          });
        }

        if (willOpen) {
          body.classList.add('is-open');
          head.classList.add('is-open');
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer.classList.contains('is-open')) closeDrawer();
    });

    // Leaving mobile width with the drawer open would strand the scroll lock.
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1000 && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  function initAll(scope) {
    qsa(scope || document, '.lzh').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-run when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
